// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BackToTopController from "./back_to_top_controller"
application.register("back-to-top", BackToTopController)

/* import GalleryController from "./gallery_controller"
 * application.register("gallery", GalleryController) */

import HeroController from "./hero_controller"
application.register("hero", HeroController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import ParallaxController from "./parallax_controller"
application.register("parallax", ParallaxController)

import CarouselAutoScrollController from "./carousel_auto_scroll_controller"
application.register("carousel-auto-scroll", CarouselAutoScrollController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import GallerySwiperController from "./gallery_swiper_controller"
application.register("gallery-swiper", GallerySwiperController)

import BlogFilterController from "./blog_filter_controller"
application.register("blog-filter", BlogFilterController)

import BlogSwiperController from "./blog_swiper_controller"
application.register("blog-swiper", BlogSwiperController)

import BlogCommentsController from "./blog_comments_controller"
application.register("blog-comments", BlogCommentsController)

import BlogUserMenuController from "./blog_user_menu_controller"
application.register("blog-user-menu", BlogUserMenuController)

import AuthModalController from "./auth_modal_controller"
application.register("auth-modal", AuthModalController)

import AdminDialogController from "./admin_dialog_controller"
application.register("admin-dialog", AdminDialogController)

import AdminDraggableController from "./admin_draggable_controller"
application.register("admin-draggable", AdminDraggableController)

import AdminImageSortController from "./admin_image_sort_controller"
application.register("admin-image-sort", AdminImageSortController)

import AdminImagePickerController from "./admin_image_picker_controller"
application.register("admin-image-picker", AdminImagePickerController)

import AdminProfileMenuController from "./admin_profile_menu_controller"
application.register("admin-profile-menu", AdminProfileMenuController)

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)
